import * as z from "zod/v4";

export const syncProductKnowledge = {
  name: "syncProductKnowledge" as const,
  input: z.object({
    /**
     * Optional Notion page ID. If provided, sync only that page. If omitted,
     * sync the full product-knowledge tree from the configured root.
     */
    pageId: z.string().optional(),
  }),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("succeeded"),
      pagesSucceeded: z.number(),
      pagesFailed: z.number(),
      chunksProcessed: z.number(),
      chunksSkipped: z.number(),
      chunksDeleted: z.number(),
    }),
    z.object({ status: z.literal("failed"), errorMessage: z.string() }),
  ]),
};
